import React from 'react'
import { connect } from 'react-redux'

import { Route, Redirect } from 'react-router-dom'
import useAccessGrant from '../../hooks/useAccessGrant'
import { UserImpl } from '../../redux/user/types'
import { PermissionLevels, Permissions } from '../../types/AccessControls'
import Loader from './Loader'

export interface AuthRouteProps {
  Component: React.ComponentType<any>
  path: string | string[]
  exact: boolean
  requiredPermission: [PermissionLevels, Permissions] | [PermissionLevels, Permissions][]
  user: UserImpl
}

const AuthRoute: React.FC<AuthRouteProps> = ({
  Component,
  path,
  exact = false,
  requiredPermission,
  user,
}) => {
  const isAuthorized = user.authorized

  const permissions = Array.isArray(requiredPermission[0])
    ? (requiredPermission as [PermissionLevels, Permissions][])
    : [requiredPermission as [PermissionLevels, Permissions]]

  const [userHasRequiredPermission, isPermissionsLoading] = useAccessGrant(permissions)

  return (
    <Route
      exact={exact}
      path={path}
      render={props =>
        isAuthorized && userHasRequiredPermission && !isPermissionsLoading ? (
          <Component {...props} />
        ) : isPermissionsLoading ? (
          <Loader spinning />
        ) : (
          <Redirect
            to={{
              pathname: userHasRequiredPermission ? '/user/login/' : '/404',
              state: { requestedPath: path },
            }}
          />
        )
      }
    />
  )
}

export default connect(({ user }: { user: UserImpl }) => ({ user }))(AuthRoute)
